import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import ShowMoreText from 'react-show-more-text';

const Container = styled.div`
  width: 100%;
  font-family: ${props => props.theme.fontFamilyHeader};
  color: ${props => props.theme.bodyColor};
  margin-bottom: 8px;
  opacity: ${props => (props.isPale ? 1.0 : 0.3)};
`;

export default function Summary({ title, isPale }) {
  const { isMobile } = React.useContext(ThemeContext);

  return (
    <Container isPale={isPale}>
      <ShowMoreText lines={isMobile ? 3 : 2} more={null} less={null}>{title}</ShowMoreText>
    </Container>
  );
}

Summary.propTypes = {
  title: PropTypes.string.isRequired,
  isPale: PropTypes.bool.isRequired,
};
